export default "__VITE_ASSET__DE4n8_xT__"